import { render, staticRenderFns } from "./PlusUserIcon.vue?vue&type=template&id=97698c1a&scoped=true&"
import script from "./PlusUserIcon.vue?vue&type=script&setup=true&lang=js&"
export * from "./PlusUserIcon.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PlusUserIcon.vue?vue&type=style&index=0&id=97698c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97698c1a",
  null
  
)

export default component.exports